import { HTTP_BASE_URL_DEV, HTTP_BASE_URL_PROD, HTTP_TIMEOUT } from "../const";

/**
 * TODO :
 * set a timeout
 */

export default class HttpService {
  /**
   *
   * @param verb
   * @param body
   * @param header
   * @returns
   */
  fetch = async (
    verb: string,
    url: string,
    body: any = {},
    header: any = {},
    options: any = {}
  ) => {
    if (!options.fileUpload) {
      header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "Fetch",
        mode: "no-cors",
      };
    }

    // if the request is internal (goes to the app server)
    if (!options.external) {
      console.log("hello");
      if (process.env.NODE_ENV !== "development") {
        url = HTTP_BASE_URL_PROD + url;
      } else {
        url = HTTP_BASE_URL_DEV + url;
      }

      if (
        !url.includes("api/owner/web/connect") &&
        !url.includes("api/owner/web/signup") &&
        !url.includes("api/owner/web/emailverification") &&
        !url.includes("api/owner/web/verifyAccount")
      ) {
        const authToken = localStorage.getItem("authToken");
        const owner = localStorage.getItem("owner");

        if (authToken == null || owner == null) {
          return { sucess: false, error: "AUTHENTICATION_ERROR" };
        }

        const parsedUser = JSON.parse(owner);

        header.Authorization = `Bearer ${authToken}`;
        body.ownerId = parsedUser.uid;
      }
    }

    console.log("args", verb, url, body, header);

    let answer: any = {};
    // HTTP.setRequestTimeout(HTTP_TIMEOUT);
    let postBody;
    switch (verb) {
      case "GET":
        answer = await this.get(url, body, header);
        console.log("ANSWER FROM PARENT FUNCTION => GET", answer);
        break;
      case "POST":
        postBody = options.fileUpload ? body : JSON.stringify(body);
        answer = await this.post(url, postBody, header);
        // answer = await this.post(url, JSON.stringify(body), header);
        console.log("ANSWER FROM PARENT FUNCTION => POST", answer);
        break;
      case "PUT":
        answer = await this.put(url, body, header);
        break;
      case "DELETE":
        answer = await this.delete(url, body, header);
        break;
    }

    return answer;
  };

  /**
   * Get function
   * @param body
   * @param header
   */
  get = async (url: string, body: any, header: any) => {
    console.log("get args", url, body, header);
    return fetch(url, {
      method: "GET",
      headers: header,
    })
      .then((response) => {
        console.log("get response", response);
        if (response.ok) {
          return response.json().then((data) => {
            console.log("response json", data);
            return data;
          });
        } else {
          return response.json().then((errorResponse) => {
            console.log("BODY", errorResponse);
            return {
              success: false,
              error: errorResponse.error,
              fullAnswer: errorResponse,
            };
          });
        }
      })
      .catch((err) => {
        console.error("error in GET request", err);
        return { success: false, error: "GET_ERROR" };
      });
  };

  /**
   * POST request
   * @param url
   * @param body
   * @param header
   */
  post = async (url: string, body: any, header: any) => {
    console.log("post args", url, body, header);
    return fetch(url, {
      method: "POST",
      body: body,
      headers: header,
    })
      .then((response) => {
        console.log("post response", response);
        if (response.ok) {
          return response.json().then((data) => {
            console.log("response json", data);
            return data;
          });
        } else {
          return response.json().then((errorResponse) => {
            console.log("BODY", errorResponse);
            return {
              success: false,
              error: errorResponse.error,
              fullAnswer: errorResponse,
            };
          });
        }
      })
      .catch((err) => {
        console.error("error in POST request", err);
        return { success: false, error: "POST_ERROR" };
      });

    // return HTTP.post(url, body, header)
    //   .then((response) => {
    //     console.log("RESPONSE FROM POST", response);
    //     return response.data;
    //   })
    //   .catch((err) => {
    //     console.error("error in POST request", err.error);
    //     console.error({ err });
    //     return err;
    //   });
  };

  /**
   * PUT request
   * @param url
   * @param body
   * @param header
   */
  put = async (url: string, body: any, header: any) => {
    // return HTTP.put(url, body, header)
    //   .then((response) => {
    //     console.log("RESPONSE FROM PUT", response);
    //     return response.data;
    //   })
    //   .catch((err) => {
    //     console.error({ err });
    //   });
  };

  /**
   * DELETE request
   * @param url
   * @param body
   * @param header
   */
  delete = async (url: string, body: any, header: any) => {
    // return HTTP.delete(url, body, header)
    //   .then((response) => {
    //     console.log("RESPONSE FROM DELETE", response);
    //     return response.data;
    //   })
    //   .catch((err) => {
    //     console.error({ err });
    //   });
  };
}
